// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CollectionsRouteImport } from './routes/collections'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FragrencesRouteImport } from './routes/fragrences'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountAddressesRouteImport } from './routes/account.addresses'
import { Route as AccountOrdersRouteImport } from './routes/account.orders'
import { Route as AccountPasswordRouteImport } from './routes/account.password'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountQuotesRouteImport } from './routes/account.quotes'
import { Route as AccountSettingsRouteImport } from './routes/account.settings'
import { Route as AccountWishlistRouteImport } from './routes/account.wishlist'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAiChatRouteImport } from './routes/admin.ai-chat'
import { Route as AdminAiSocialRouteImport } from './routes/admin.ai-social'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminBlogRouteImport } from './routes/admin.blog'
import { Route as AdminBlogTaxonomyRouteImport } from './routes/admin.blog-taxonomy'
import { Route as AdminCmsRouteImport } from './routes/admin.cms'
import { Route as AdminContentRouteImport } from './routes/admin.content'
import { Route as AdminCustomersRouteImport } from './routes/admin.customers'
import { Route as AdminDevToolsRouteImport } from './routes/admin.dev-tools'
import { Route as AdminEmailDiagnosticsRouteImport } from './routes/admin.email-diagnostics'
import { Route as AdminEnquiriesRouteImport } from './routes/admin.enquiries'
import { Route as AdminFaqRouteImport } from './routes/admin.faq'
import { Route as AdminIntegrationsRouteImport } from './routes/admin.integrations'
import { Route as AdminInventoryRouteImport } from './routes/admin.inventory'
import { Route as AdminMediaRouteImport } from './routes/admin.media'
import { Route as AdminOrdersRouteImport } from './routes/admin.orders'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminPromosRouteImport } from './routes/admin.promos'
import { Route as AdminRolesRouteImport } from './routes/admin.roles'
import { Route as AdminSearchRouteImport } from './routes/admin.search'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminShippingPartnersRouteImport } from './routes/admin.shipping-partners'
import { Route as AdminSubscribersRouteImport } from './routes/admin.subscribers'
import { Route as AdminTenantsRouteImport } from './routes/admin.tenants'
import { Route as AdminVideoGalleryRouteImport } from './routes/admin.video-gallery'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CollectionsIndexRouteImport } from './routes/collections.index'
import { Route as CollectionsSlugRouteImport } from './routes/collections.$slug'
import { Route as CorporateIndexRouteImport } from './routes/corporate.index'
import { Route as CorporateSlugRouteImport } from './routes/corporate.$slug'
import { Route as FragrancesIndexRouteImport } from './routes/fragrances.index'
import { Route as FragrancesSlugRouteImport } from './routes/fragrances.$slug'
import { Route as InvoiceIdRouteImport } from './routes/invoice.$id'
import { Route as OrderIdRouteImport } from './routes/order.$id'
import { Route as PacksIndexRouteImport } from './routes/packs.index'
import { Route as PacksSlugRouteImport } from './routes/packs.$slug'
import { Route as RetailIndexRouteImport } from './routes/retail.index'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopCategoryRouteImport } from './routes/shop.$category'
import { Route as AdminAnalyticsCustomersRouteImport } from './routes/admin.analytics_.customers'
import { Route as AdminAnalyticsInventoryRouteImport } from './routes/admin.analytics_.inventory'
import { Route as AdminAnalyticsSalesRouteImport } from './routes/admin.analytics_.sales'
import { Route as AdminBlogIdRouteImport } from './routes/admin.blog.$id'
import { Route as AdminCampaignsIndexRouteImport } from './routes/admin.campaigns.index'
import { Route as AdminCampaignsIdRouteImport } from './routes/admin.campaigns.$id'
import { Route as AdminCmsSlugRouteImport } from './routes/admin.cms.$slug'
import { Route as AdminCollectionsIndexRouteImport } from './routes/admin.collections.index'
import { Route as AdminCollectionsIdRouteImport } from './routes/admin.collections.$id'
import { Route as AdminPacksIndexRouteImport } from './routes/admin.packs.index'
import { Route as AdminPacksIdRouteImport } from './routes/admin.packs.$id'
import { Route as AdminQuotesIndexRouteImport } from './routes/admin.quotes.index'
import { Route as AdminQuotesIdRouteImport } from './routes/admin.quotes.$id'
import { Route as AdminSocialIndexRouteImport } from './routes/admin.social.index'
import { Route as AdminSocialIdRouteImport } from './routes/admin.social.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const CollectionsRoute = CollectionsRouteImport.update({
            id: '/collections',path: '/collections',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FragrencesRoute = FragrencesRouteImport.update({
            id: '/fragrences',path: '/fragrences',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReturnsRoute = ReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SetupRoute = SetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => rootRouteImport
          })
const ShippingRoute = ShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AccountRoute
          })
const AccountAddressesRoute = AccountAddressesRouteImport.update({
            id: '/addresses',path: '/addresses',getParentRoute: () => AccountRoute
          })
const AccountOrdersRoute = AccountOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AccountRoute
          })
const AccountPasswordRoute = AccountPasswordRouteImport.update({
            id: '/password',path: '/password',getParentRoute: () => AccountRoute
          })
const AccountProfileRoute = AccountProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AccountRoute
          })
const AccountQuotesRoute = AccountQuotesRouteImport.update({
            id: '/quotes',path: '/quotes',getParentRoute: () => AccountRoute
          })
const AccountSettingsRoute = AccountSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AccountRoute
          })
const AccountWishlistRoute = AccountWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AccountRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAiChatRoute = AdminAiChatRouteImport.update({
            id: '/ai-chat',path: '/ai-chat',getParentRoute: () => AdminRoute
          })
const AdminAiSocialRoute = AdminAiSocialRouteImport.update({
            id: '/ai-social',path: '/ai-social',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRoute
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AdminRoute
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AdminRoute
          })
const AdminBlogTaxonomyRoute = AdminBlogTaxonomyRouteImport.update({
            id: '/blog-taxonomy',path: '/blog-taxonomy',getParentRoute: () => AdminRoute
          })
const AdminCmsRoute = AdminCmsRouteImport.update({
            id: '/cms',path: '/cms',getParentRoute: () => AdminRoute
          })
const AdminContentRoute = AdminContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AdminRoute
          })
const AdminCustomersRoute = AdminCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => AdminRoute
          })
const AdminDevToolsRoute = AdminDevToolsRouteImport.update({
            id: '/dev-tools',path: '/dev-tools',getParentRoute: () => AdminRoute
          })
const AdminEmailDiagnosticsRoute = AdminEmailDiagnosticsRouteImport.update({
            id: '/email-diagnostics',path: '/email-diagnostics',getParentRoute: () => AdminRoute
          })
const AdminEnquiriesRoute = AdminEnquiriesRouteImport.update({
            id: '/enquiries',path: '/enquiries',getParentRoute: () => AdminRoute
          })
const AdminFaqRoute = AdminFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => AdminRoute
          })
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AdminRoute
          })
const AdminInventoryRoute = AdminInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => AdminRoute
          })
const AdminMediaRoute = AdminMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AdminRoute
          })
const AdminOrdersRoute = AdminOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AdminRoute
          })
const AdminProductsRoute = AdminProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AdminRoute
          })
const AdminPromosRoute = AdminPromosRouteImport.update({
            id: '/promos',path: '/promos',getParentRoute: () => AdminRoute
          })
const AdminRolesRoute = AdminRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => AdminRoute
          })
const AdminSearchRoute = AdminSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminShippingPartnersRoute = AdminShippingPartnersRouteImport.update({
            id: '/shipping-partners',path: '/shipping-partners',getParentRoute: () => AdminRoute
          })
const AdminSubscribersRoute = AdminSubscribersRouteImport.update({
            id: '/subscribers',path: '/subscribers',getParentRoute: () => AdminRoute
          })
const AdminTenantsRoute = AdminTenantsRouteImport.update({
            id: '/tenants',path: '/tenants',getParentRoute: () => AdminRoute
          })
const AdminVideoGalleryRoute = AdminVideoGalleryRouteImport.update({
            id: '/video-gallery',path: '/video-gallery',getParentRoute: () => AdminRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CollectionsRoute
          })
const CollectionsSlugRoute = CollectionsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CollectionsRoute
          })
const CorporateIndexRoute = CorporateIndexRouteImport.update({
            id: '/corporate/',path: '/corporate/',getParentRoute: () => rootRouteImport
          })
const CorporateSlugRoute = CorporateSlugRouteImport.update({
            id: '/corporate/$slug',path: '/corporate/$slug',getParentRoute: () => rootRouteImport
          })
const FragrancesIndexRoute = FragrancesIndexRouteImport.update({
            id: '/fragrances/',path: '/fragrances/',getParentRoute: () => rootRouteImport
          })
const FragrancesSlugRoute = FragrancesSlugRouteImport.update({
            id: '/fragrances/$slug',path: '/fragrances/$slug',getParentRoute: () => rootRouteImport
          })
const InvoiceIdRoute = InvoiceIdRouteImport.update({
            id: '/invoice/$id',path: '/invoice/$id',getParentRoute: () => rootRouteImport
          })
const OrderIdRoute = OrderIdRouteImport.update({
            id: '/order/$id',path: '/order/$id',getParentRoute: () => rootRouteImport
          })
const PacksIndexRoute = PacksIndexRouteImport.update({
            id: '/packs/',path: '/packs/',getParentRoute: () => rootRouteImport
          })
const PacksSlugRoute = PacksSlugRouteImport.update({
            id: '/packs/$slug',path: '/packs/$slug',getParentRoute: () => rootRouteImport
          })
const RetailIndexRoute = RetailIndexRouteImport.update({
            id: '/retail/',path: '/retail/',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/shop/',path: '/shop/',getParentRoute: () => rootRouteImport
          })
const ShopCategoryRoute = ShopCategoryRouteImport.update({
            id: '/shop/$category',path: '/shop/$category',getParentRoute: () => rootRouteImport
          })
const AdminAnalyticsCustomersRoute = AdminAnalyticsCustomersRouteImport.update({
            id: '/analytics_/customers',path: '/analytics/customers',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsInventoryRoute = AdminAnalyticsInventoryRouteImport.update({
            id: '/analytics_/inventory',path: '/analytics/inventory',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsSalesRoute = AdminAnalyticsSalesRouteImport.update({
            id: '/analytics_/sales',path: '/analytics/sales',getParentRoute: () => AdminRoute
          })
const AdminBlogIdRoute = AdminBlogIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminBlogRoute
          })
const AdminCampaignsIndexRoute = AdminCampaignsIndexRouteImport.update({
            id: '/campaigns/',path: '/campaigns/',getParentRoute: () => AdminRoute
          })
const AdminCampaignsIdRoute = AdminCampaignsIdRouteImport.update({
            id: '/campaigns/$id',path: '/campaigns/$id',getParentRoute: () => AdminRoute
          })
const AdminCmsSlugRoute = AdminCmsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AdminCmsRoute
          })
const AdminCollectionsIndexRoute = AdminCollectionsIndexRouteImport.update({
            id: '/collections/',path: '/collections/',getParentRoute: () => AdminRoute
          })
const AdminCollectionsIdRoute = AdminCollectionsIdRouteImport.update({
            id: '/collections/$id',path: '/collections/$id',getParentRoute: () => AdminRoute
          })
const AdminPacksIndexRoute = AdminPacksIndexRouteImport.update({
            id: '/packs/',path: '/packs/',getParentRoute: () => AdminRoute
          })
const AdminPacksIdRoute = AdminPacksIdRouteImport.update({
            id: '/packs/$id',path: '/packs/$id',getParentRoute: () => AdminRoute
          })
const AdminQuotesIndexRoute = AdminQuotesIndexRouteImport.update({
            id: '/quotes/',path: '/quotes/',getParentRoute: () => AdminRoute
          })
const AdminQuotesIdRoute = AdminQuotesIdRouteImport.update({
            id: '/quotes/$id',path: '/quotes/$id',getParentRoute: () => AdminRoute
          })
const AdminSocialIndexRoute = AdminSocialIndexRouteImport.update({
            id: '/social/',path: '/social/',getParentRoute: () => AdminRoute
          })
const AdminSocialIdRoute = AdminSocialIdRouteImport.update({
            id: '/social/$id',path: '/social/$id',getParentRoute: () => AdminRoute
          })





const AccountRouteChildren = {
  AccountAddressesRoute: AccountAddressesRoute,AccountOrdersRoute: AccountOrdersRoute,AccountPasswordRoute: AccountPasswordRoute,AccountProfileRoute: AccountProfileRoute,AccountQuotesRoute: AccountQuotesRoute,AccountSettingsRoute: AccountSettingsRoute,AccountWishlistRoute: AccountWishlistRoute,AccountIndexRoute: AccountIndexRoute
}

const AccountRouteWithChildren = AccountRoute._addFileChildren(AccountRouteChildren)




const AdminBlogRouteChildren = {
  AdminBlogIdRoute: AdminBlogIdRoute
}

const AdminBlogRouteWithChildren = AdminBlogRoute._addFileChildren(AdminBlogRouteChildren)




const AdminCmsRouteChildren = {
  AdminCmsSlugRoute: AdminCmsSlugRoute
}

const AdminCmsRouteWithChildren = AdminCmsRoute._addFileChildren(AdminCmsRouteChildren)



const AdminRouteChildren = {
  AdminAiChatRoute: AdminAiChatRoute,AdminAiSocialRoute: AdminAiSocialRoute,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminAuditRoute: AdminAuditRoute,AdminBlogRoute: AdminBlogRouteWithChildren,AdminBlogTaxonomyRoute: AdminBlogTaxonomyRoute,AdminCmsRoute: AdminCmsRouteWithChildren,AdminContentRoute: AdminContentRoute,AdminCustomersRoute: AdminCustomersRoute,AdminDevToolsRoute: AdminDevToolsRoute,AdminEmailDiagnosticsRoute: AdminEmailDiagnosticsRoute,AdminEnquiriesRoute: AdminEnquiriesRoute,AdminFaqRoute: AdminFaqRoute,AdminIntegrationsRoute: AdminIntegrationsRoute,AdminInventoryRoute: AdminInventoryRoute,AdminMediaRoute: AdminMediaRoute,AdminOrdersRoute: AdminOrdersRoute,AdminProductsRoute: AdminProductsRoute,AdminPromosRoute: AdminPromosRoute,AdminRolesRoute: AdminRolesRoute,AdminSearchRoute: AdminSearchRoute,AdminSettingsRoute: AdminSettingsRoute,AdminShippingPartnersRoute: AdminShippingPartnersRoute,AdminSubscribersRoute: AdminSubscribersRoute,AdminTenantsRoute: AdminTenantsRoute,AdminVideoGalleryRoute: AdminVideoGalleryRoute,AdminIndexRoute: AdminIndexRoute,AdminAnalyticsCustomersRoute: AdminAnalyticsCustomersRoute,AdminAnalyticsInventoryRoute: AdminAnalyticsInventoryRoute,AdminAnalyticsSalesRoute: AdminAnalyticsSalesRoute,AdminCampaignsIdRoute: AdminCampaignsIdRoute,AdminCollectionsIdRoute: AdminCollectionsIdRoute,AdminPacksIdRoute: AdminPacksIdRoute,AdminQuotesIdRoute: AdminQuotesIdRoute,AdminSocialIdRoute: AdminSocialIdRoute,AdminCampaignsIndexRoute: AdminCampaignsIndexRoute,AdminCollectionsIndexRoute: AdminCollectionsIndexRoute,AdminPacksIndexRoute: AdminPacksIndexRoute,AdminQuotesIndexRoute: AdminQuotesIndexRoute,AdminSocialIndexRoute: AdminSocialIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const CollectionsRouteChildren = {
  CollectionsSlugRoute: CollectionsSlugRoute,CollectionsIndexRoute: CollectionsIndexRoute
}

const CollectionsRouteWithChildren = CollectionsRoute._addFileChildren(CollectionsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountRoute: AccountRouteWithChildren,AdminRoute: AdminRouteWithChildren,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,CollectionsRoute: CollectionsRouteWithChildren,ContactRoute: ContactRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,FragrencesRoute: FragrencesRoute,LoginRoute: LoginRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,ReturnsRoute: ReturnsRoute,SearchRoute: SearchRoute,SetupRoute: SetupRoute,ShippingRoute: ShippingRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,VerifyEmailRoute: VerifyEmailRoute,BlogSlugRoute: BlogSlugRoute,CorporateSlugRoute: CorporateSlugRoute,FragrancesSlugRoute: FragrancesSlugRoute,InvoiceIdRoute: InvoiceIdRoute,OrderIdRoute: OrderIdRoute,PacksSlugRoute: PacksSlugRoute,ShopCategoryRoute: ShopCategoryRoute,BlogIndexRoute: BlogIndexRoute,CorporateIndexRoute: CorporateIndexRoute,FragrancesIndexRoute: FragrancesIndexRoute,PacksIndexRoute: PacksIndexRoute,RetailIndexRoute: RetailIndexRoute,ShopIndexRoute: ShopIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)